import { render, staticRenderFns } from "./FolderDetails.vue?vue&type=template&id=11daa69c&"
import script from "./FolderDetails.vue?vue&type=script&lang=js&"
export * from "./FolderDetails.vue?vue&type=script&lang=js&"
import style0 from "./FolderDetails.vue?vue&type=style&index=0&id=11daa69c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports